import moment from 'moment'

export default {
  data() {
    return {
      tpBirthDate: moment().subtract(18, "years"),
      payModalTitle: '微信扫码进行支付',
      payVisible: false,
      payQrcode: '',
      offsetDay: '',
      totalPremium: 0
    }
  },
  created() {
    let { productCode, u, p } = this.$route.query;

    const userId = u
    if (!productCode || !p) {
      return;
    }
    productCode = productCode || p
    this.userParams = {
      //从地址中获取
      userId,
      productCode
    };
    console.log('this.userParams -> ', this.userParams)
  },
  methods: {
    handlePayModalClose() {
      if (this.paySi) {
        this._policyId = ''
        clearInterval(this.paySi);
      }
    },
    handleIdCardBlur(param) {
      let pre = param
      if (typeof param !== 'string') {
        pre = ''
      }
      const type = this.form.getFieldValue(`${pre}idType`)
      const value = this.form.getFieldValue(`${pre}idNumber`)
      console.log('开始身份证解析生日跟性别', value, type)
      if (this.$regTest.checkIdCard(value) && type == "1") {
        let year = value.slice(6, 10);
        let mon = value.slice(10, 12);
        let day = value.slice(12, 14);
        let birth = year + "-" + mon + "-" + day;
        let sex = value.slice(16, 17) % 2 == 1 ? "M" : "F";
        let obj = {}
        obj[`${pre}gender`] = sex
        obj[`${pre}birthDate`] = moment(birth)
        this.form.setFieldsValue(obj)
        console.log('解析值 -> ', this.formInfo, sex, birth)
      }
      this.handleCountPremium()
    },
    handleOpenChange() {
      // 起止日期控制弹层
      this.openDateSelect = !this.openDateSelect
      this._startDate = null
      console.log('handleOpenChange -> ', this.openDateSelect)
    },
    calendarChange(arr, arrstr) {
      console.log('calendarChange -> ', arr, arrstr)
      const mannalSetTime = () => {
        this.openDateSelect = false
        this.form.setFieldsValue({
          rangeDate: this.planRangeDate
        })
        this.rangePicker(this.planRangeDate)
      }
      if (arr[0] && this.fullYearPlan) {
        this.planRangeDate = [arr[0], moment(arr[0]).add(1, 'years').subtract(1, 'days')]
        mannalSetTime()
      }
      this._startDate = arr[0] // 记录用来disabledDate Select
    },
    calcPremium(days) {
      this.sumPremium = this._calcPremium(this._planIndex || 1, days)
    },
    rangePicker(values) {
      const startDate = values[0].format("YYYY-MM-DD");
      let offsetDay = values[1].diff(values[0], 'days') + 1;
      this.offsetDay = offsetDay;
      this.planOffsetDay = offsetDay;
      this._effectiveDate = startDate;
      // 不是全年计划，并且选择天数 > 364
      if (!this.fullYearPlan && offsetDay > 90) {
        this.$message.error('每次承保旅程最长期限为90天');
        this.clearRangeDateSelect(1000);
        return;
      }
      if (!this.fullYearPlan && offsetDay > 364) {
        this.$message.info('若保障全年，请选择全年计划方案');
        this.clearRangeDateSelect(1000);
        return;
      }
      // 中银：经济计划、升级计划：选择的保障期间大于126天时候/白金计划选择的保障期间大于133天时候，提示“所选保障期间的保费已大于全年计划的保费，请投保全年保障计划！”
      if ((((this._planValue == 1 || this._planValue == 2) && offsetDay > 126)
        || (this._planValue == 3 && offsetDay > 133)) && this._productType == 'ZY'
      ) {
        this.$message.info('所选保障期间的保费已大于全年计划的保费，请投保全年保障计划！');
        this.clearRangeDateSelect(1000);
        return;
      }
      if( this.userParams.productCode != 'BOCI19' ) {
        this.calcPremium(offsetDay > 364 ? 'year' : offsetDay)
      }
      this.handleCountPremium()
      console.log("计划时间范围选择 -> ", this.offsetDay, values);
    },
    handleIdTypeSelectChange(c, pre) {
      console.log(c);
      // 通用选择校验
      if (typeof pre != 'string') {
        pre = ''
      }
      const key = `${pre}idNumber`
      const idNumber = this.form.getFieldValue(key)
      if (idNumber) {
        this.form.setFieldsValue({
          [key]: ''
        })
      }
      this.handleCountPremium()
    },
    checkIDNumber(rule, value, callback, pre) {
      var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      let form = this.form
      if (value && form.getFieldValue(pre) == '1' && !regIdCard.test(value)) {
        callback('身份证号码不正确')
      } else {
        callback()
      }
    },
    checkAddress(rule, value, callback) {
      var patrn = /["'“”‘']/im;
      if (patrn.test(value)) {
        callback('地址不能包含特殊符号')
      } else {
        callback()
      }
    }
  }
}